var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockUndfOpen = function SvgLockUndfOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87257 7.77337H18.9303C19.1252 7.77337 19.283 7.9334 19.283 8.13116V17.0756C19.283 17.8649 18.6504 18.5067 17.8726 18.5067H8C7.22214 18.5067 6.58962 17.8649 6.58962 17.0756V8.13116C6.58962 7.9334 6.74733 7.77337 6.94222 7.77337H7.75701L7.75701 6.34225C7.72943 5.82966 7.53307 5.04168 7.02641 4.42219C6.50993 3.84385 5.76418 3.48004 4.93629 3.48004C3.44297 3.48004 2.21692 4.6637 2.12153 6.15494C2.11757 6.21687 2.11556 7.61266 2.11556 7.67559H0C0 7.61288 0.00114091 6.2171 0.00340398 6.15494C0.100814 3.47946 2.27616 1.33337 4.93629 1.33337C7.65821 1.33337 9.87257 3.58033 9.87257 6.34225V7.77337Z",
    fill: "#FF3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9039 15.5253C13.9707 15.4494 14.0027 15.3481 13.9917 15.2471L13.7693 13.2175C14.1305 12.9509 14.3464 12.5292 14.3464 12.0666C14.3464 11.2773 13.7139 10.6355 12.936 10.6355C12.1582 10.6355 11.5256 11.2774 11.5256 12.0666C11.5256 12.5292 11.7415 12.9509 12.1027 13.2175L11.8803 15.2471C11.8692 15.3481 11.9013 15.4495 11.9681 15.5253C12.0349 15.6011 12.1306 15.6444 12.2308 15.6444H13.6412C13.7414 15.6444 13.8371 15.6011 13.9039 15.5253Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockUndfOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-undf-open.5b17a1f6.svg";
export { ForwardRef as ReactComponent };